import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { STORAGE_KEYS, type Permission } from '@/lib/config/constants';

export interface RoleDefinition {
  id: string;
  label: string;
  permissions: Permission[];

  system: boolean;

  editable?: boolean;
}

interface RolesState {
  roles: RoleDefinition[];
  setRoles(roles: RoleDefinition[]): void;
}

export const useRolesStore = create<RolesState>()(
  persist(
    (set) => ({
      roles: [],
      setRoles: (roles) => set({ roles }),
    }),
    {
      name: STORAGE_KEYS.roles,
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ roles: s.roles }),
    },
  ),
);
